module.exports = __webpack_public_path__ + "img/screens-pluska.900904b4.png";